//
// Generated class BankMovementBalance
//

/// <reference path="BankMovementBalance_ManagedObject.ts" />

class BankMovementBalance extends BankMovementBalance_ManagedObject
{

}
